<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="tab-box">
        <custom-tab-box :tabData="tabData" @change="handleChangeTab" :selectTab="selectTab"></custom-tab-box>
      </div>
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="提交时间:">
                <custom-date-range
                  :start-date="searchForm.feedbackTimeStart"
                  :end-date="searchForm.feedbackTimeEnd"
                  @update:startDate="
                    (val) => (searchForm.feedbackTimeStart = val)
                  "
                  @update:endDate="(val) => (searchForm.feedbackTimeEnd = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="问题类型:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.feedbackType"
                  filterable
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in getConfig('feedback_type')"
                    :key="item.dictLabel"
                    :label="item.dictLabel"
                    :value="item.dictLabel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="处理状态:" prop="reply">
                <el-select style="width: 100%" v-model="searchForm.reply" filterable clearable placeholder="请选择">
                  <el-option label="已处理" :value="true"></el-option>
                  <el-option label="未处理" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:reply="{ row }">
          <div class="common-status status-in-progress" v-if="row.reply">已处理</div>
          <div class="common-status status-pending-order" v-else>待处理</div>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" :class="row.reply ? 'disable-txt' : ''" @click="row.reply ? '' : handleDeal(row)">
            处理
          </span>
          <span class="operate-btn" @click="handleDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { getConfig } from "@/utils/localDict";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        belongCompanyId: "",
        feedbackTimeEnd: "",
        feedbackTimeStart: "",
        feedbackType: "",
        reply: "",
        terminalType: 2,
      },
      selectTab: 2,
      tabData: [
        {
          label: 2,
          value: "代理商",
        },
        {
          label: 3,
          value: "服务商",
        },
      ],
      deptList: [],

      isImmediatelyGetData: true,
      haveBelongCompany: true,
      tableColumn2: [
        {
          label: "提交时间",
          prop: "feedbackTime",
          align: "left",
          show: true,
        },
        {
          label: "所属代理商",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "用户姓名",
          prop: "feedbackUsername",
          align: "left",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "问题类型",
          prop: "feedbackType",
          align: "left",
          show: true,
        },
        {
          label: "反馈描述",
          prop: "feedbackContent",
          align: "left",
          show: true,
        },
        {
          label: "处理状态",
          prop: "reply",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      tableColumn3: [
        {
          label: "提交时间",
          prop: "feedbackTime",
          align: "left",
          show: true,
        },
        {
          label: "所属服务商",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "用户姓名",
          prop: "feedbackUsername",
          align: "left",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "问题类型",
          prop: "feedbackType",
          align: "left",
          show: true,
        },
        {
          label: "反馈描述",
          prop: "feedbackContent",
          align: "left",
          show: true,
        },
        {
          label: "处理状态",
          prop: "reply",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  computed: {
    tableColumn: function (){
      return this['tableColumn'+this.selectTab];
    }
  },
  created() {},
  mounted() {},
  methods: {
    getConfig,
    handleChangeTab(val) {
      this.searchForm.belongCompanyId = this.belongCompanyId;
      this.searchForm.terminalType = val;
      this.selectTab = val;
      this.tableOptions.currentPage = 1;
      this.searchForm.feedbackTimeEnd = "";
      this.searchForm.feedbackTimeStart = "";
      this.searchForm.feedbackType = "";
      this.searchForm.reply = "";
      this.getTableData();
    },
    handleDeal(row) {
      this.$refs.addOrEdit.init("投诉建议处理", false, row);
    },
    handleDetail(row) {
      this.$refs.addOrEdit.init("投诉建议处理", true, row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-table-box {
    padding-top: 0;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
